import { useState } from "react";
import { saveEvolutionAPI, saveEvolutionExtraAPI, updateEvolutionAPI, updateEvolutionExtraAPI } from "../../../api/protocol";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useEvolutions = (visitType) => {
    const [isLoading, setIsLoading] = useState(false);

    const updateEvolution = async (protocolId, visitId, patientId, evolutionId, evolution, audit) => {
        try {
            var pepepe = {
                evolution: evolution,
                audit: audit
            }
            setIsLoading(true);
            let evolutionRes = null;
            if (visitType === "VisitTrackingExtra")
                evolutionRes = await updateEvolutionExtraAPI(protocolId, visitId, patientId, evolutionId, pepepe);
            else
                evolutionRes = await updateEvolutionAPI(protocolId, visitId, patientId, evolutionId, pepepe);
            setIsLoading(false);

            return evolutionRes;

        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const saveEvolution = async (protocolId, visitId, patientId, medicalRecordNumber, evolution, audit) => {

        try {
            var pepepe = {
                evolution: evolution,
                audit: audit
            }
            setIsLoading(true);
            let evolutionRes = null;
            if (visitType === "VisitTrackingExtra")
                evolutionRes = await saveEvolutionExtraAPI(protocolId, visitId, patientId, medicalRecordNumber, pepepe);
            else
                evolutionRes = await saveEvolutionAPI(protocolId, visitId, patientId, medicalRecordNumber, pepepe);
            setIsLoading(false);

            return evolutionRes;

        } catch (error) {
            console.log(error)
            HandleApiError(error);
            setIsLoading(false);

            throw error;
        }
    }

    return [isLoading, saveEvolution, updateEvolution];
}